export default __webpack_public_path__ + "static/media/socio-on.03e84060.svg";